import React from "react";

import StatusScreen from "components/StatusScreen";

export default function Unauthenticated({ fallbackUrl, fallbackText, external }) {
  const label = fallbackText || "Log me in";
  const action = external ? { href: fallbackUrl, label } : { to: fallbackUrl || "/login", label };
  return (
    <StatusScreen image="illustration-private.jpg" title="Wow! How are you here?" action={action}>
      Seems like you do not have access to this page. We are sorry.
    </StatusScreen>
  );
}
